// import request from '@/utils/request'
import {
    get,
    post,
    // postForm,
    // postJson,
} from './http/http';

const httpServer ={
    loginByUsername(params){
        return post('/login/login',params);
    },

    logout(params){
        return post('/login/logout',params);
    },

    getUserInfo(params){
        return get('/user/info',params);
    },
}

export default httpServer;


